var PaymentGateController = (function () {
    function PaymentGateController(topic, $state) {
        this.topic = topic;
        this.$state = $state;
        this.CALC_VERSION_2 = 2;
        this.CALC_VERSION_1 = 1;
        this.calculationVersion = topic.topic.calculationVersion || this.CALC_VERSION_1;
    }
    PaymentGateController.$inject = [
        'topic',
        '$state'
    ];
    return PaymentGateController;
}());
angular
    .module('application')
    .component('paymentGate', new PaymentGateComponent());

//# sourceMappingURL=paymentGateController.js.map
